import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// Navbar links 
import HomePage from "./home/page";
import About from "./about/page";
import Products from "./products/page";
import Contact from "./contact/page";

import Insecticides from "./Insecticides/page";
import Fungicide from "./Fungicide/page";
import Herbicide from "./Herbicide/page";
import Fertilizer from "./Fertilizer/page";
import PlantGrowthRegulator from "./PGR/page";
import ProductDetails from "./ProductDetails/ProductDetails";
import NPKFertilizer from "./NPK/NPK";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/Productdetail" element={<ProductDetails />} />

        <Route path="/products/insecticides" element={<Insecticides />} />
        <Route path="/products/fungicide" element={<Fungicide />} />
        <Route path="/products/herbicide" element={<Herbicide />} />
        <Route path="/products/fertilizer" element={<Fertilizer />} />
        <Route path="/products/PGR" element={<PlantGrowthRegulator />} />
        <Route path="/products/NPK" element={<NPKFertilizer />} />

        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
